import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './component/Header';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Recrutement from './pages/Recrutement';
import ServiceDetail from './pages/ServiceDetail';
import Contact from './pages/Contact';
import Book from './pages/Book';
import Footer from './component/Footer';



function App() {
  return (
    <Router>
      <div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/service/:id" element={<ServiceDetail />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Recrutement" element={<Recrutement />} />
          <Route path="/Book" element={<Book />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
